import React from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  HiOutlineShieldCheck, HiOutlineGlobeAlt, HiOutlineServer, HiOutlineArchiveBox,
  HiOutlineEnvelope, HiOutlineRocketLaunch, HiOutlineBeaker, HiOutlineWrenchScrewdriver,
  HiOutlineCog6Tooth, HiOutlineDocumentText, HiOutlineLockClosed, HiOutlineBuildingOffice2,
  HiOutlineChartBar, HiOutlineBriefcase, HiOutlineUserGroup, HiOutlineMapPin,
  HiOutlineFingerPrint, HiOutlineCircleStack, HiOutlineCpuChip, HiOutlineComputerDesktop,
  HiOutlineCloud, HiOutlineBolt, HiOutlineMagnifyingGlass, HiOutlineSignal,
  HiOutlineShieldExclamation, HiOutlineCloudArrowUp, HiOutlinePresentationChartBar
} from 'react-icons/hi2';

const allSolutions = [
  { icon: <HiOutlineShieldCheck size={28} />, title: 'Siber Güvenlik', slug: 'guvenlik', desc: 'İstanbul, Ankara ve İzmir veri merkezlerinde çok katmanlı güvenlik çözümleri.', path: '/cozumler/guvenlik' },
  { icon: <HiOutlineGlobeAlt size={28} />, title: 'Network Çözümleri', slug: 'network', desc: 'Türkiye genelinde güvenli ve yönetilebilir ağ altyapı çözümleri.', path: '/cozumler/network' },
  { icon: <HiOutlineServer size={28} />, title: 'Veri Merkezi', slug: 'veri-merkezi', desc: 'Tier 3+ sertifikalı veri merkezlerinde colocation ve managed hosting.', path: '/cozumler/veri-merkezi' },
  { icon: <HiOutlineArchiveBox size={28} />, title: 'Yedekleme & Arşivleme', slug: 'yedekleme', desc: 'KVKK uyumlu bulut tabanlı yedekleme ve uzun süreli arşivleme çözümleri.', path: '/cozumler/yedekleme' },
  { icon: <HiOutlineEnvelope size={28} />, title: 'Mail Çözümleri', slug: 'mail', desc: 'Yapay zeka destekli, güvenli ve yönetilebilir kurumsal e-posta hizmetleri.', path: '/cozumler/mail' },
  { icon: <HiOutlineRocketLaunch size={28} />, title: 'Startup Çözümleri', slug: 'startup', desc: 'Startup şirketler için özel fiyatlandırma ve esnek büyüme modelleri.', path: '/cozumler/startup' },
  { icon: <HiOutlineBeaker size={28} />, title: 'Geliştirme & Test', slug: 'gelistirme-test', desc: 'CI/CD pipeline, test otomasyonu ve DevOps çözümleri.', path: '/cozumler/gelistirme-test' },
  { icon: <HiOutlineWrenchScrewdriver size={28} />, title: 'Yerinde Destek', slug: 'yerinde-destek', desc: 'İstanbul, Ankara ve İzmir\'de uzman ekiple yerinde teknik destek.', path: '/cozumler/yerinde-destek' },
  { icon: <HiOutlineCog6Tooth size={28} />, title: 'Parça Tedarik', slug: 'parca-tedarik', desc: 'Sunucu ve network donanım yedek parça tedarik çözümleri.', path: '/cozumler/parca-tedarik' },
  { icon: <HiOutlineDocumentText size={28} />, title: 'KVKK Danışmanlığı', slug: 'kvkk', desc: 'KVKK uyumluluk denetimi, veri envanterleme ve teknik çözümler.', path: '/cozumler/kvkk' },
];

const solutionDetails = {
  'guvenlik': {
    longDesc: 'EMUR Innovation Siber Güvenlik çözümleri, İstanbul, Ankara ve İzmir\'deki veri merkezlerinden işletmenizi dijital tehditlere karşı çok katmanlı savunma stratejisi ile korur. Ağ güvenliği, uç nokta koruması, kimlik yönetimi ve Güvenlik Operasyonları Merkezi (SOC) hizmetimiz ile 7/24 korunma altındasınız. Türkiye\'nin siber güvenlik manzarası her geçen gün daha karmaşık hale gelirken, EMUR Innovation olarak en güncel tehdit istihbaratı ve saldırı önleme teknolojileri ile işletmenizin dijital varlıklarını koruyoruz.',
    stats: [
      { icon: '🛡️', number: '7/24', text: 'SOC İzleme' },
      { icon: '🔍', number: '10Tbps+', text: 'DDoS Scrubbing' },
      { icon: '📊', number: '500K+', text: 'Günlük Olay Analizi' },
      { icon: '⚡', number: '<15dk', text: 'Ortalama Yanıt Süresi' },
    ],
    deepDive: {
      title: '🛡️ Türkiye\'de Siber Güvenlik Tehditleri ve Savunma Stratejileri',
      paragraphs: [
        'Türkiye, coğrafi konumu ve ekonomik büyümesi nedeniyle siber saldırganlar için yüksek değerli bir hedef olmaya devam etmektedir. BTK verilerine göre Türkiye\'ye yönelik siber saldırılar son üç yılda %150 oranında artış göstermiştir. Fidye yazılımı (ransomware), oltalama (phishing), DDoS saldırıları ve tedarik zinciri saldırıları en yaygın tehdit vektörleridir. EMUR Innovation olarak İstanbul, Ankara ve İzmir\'deki SOC merkezlerimizden bu tehditlere karşı proaktif savunma hizmetleri sunuyoruz.',
        'Güvenlik Operasyonları Merkezi (SOC) hizmetimiz, SIEM (Security Information and Event Management) platformumuz üzerinde 7/24 kesintisiz çalışır. Günde 500.000\'in üzerinde güvenlik olayını analiz eden SOC ekibimiz, yapay zeka destekli anomali tespiti ile gerçek tehditleri yanlış pozitiflerden ayırır. Tespit edilen tehditler, MITRE ATT&CK framework\'ü üzerinden sınıflandırılır ve önceden tanımlanmış playbook\'lara göre otomatik veya manuel müdahale gerçekleştirilir.',
        'Yeni nesil firewall (NGFW) çözümlerimiz, geleneksel paket filtrelemenin ötesinde uygulama katmanı denetimi, SSL/TLS inceleme, sandboxing ve gelişmiş tehdit koruması (ATP) sunar. İstanbul, Ankara ve İzmir veri merkezlerimizdeki firewall kümeleri, aktif-aktif yapılandırma ile sıfır tek hata noktası politikasıyla çalışır. Her bir lokasyonda yedekli firewall çiftleri, donanım arızası durumunda bile kesintisiz koruma sağlar.',
        'DDoS koruma hizmetimiz, 10 Tbps\'nin üzerinde scrubbing kapasitesi ile volumetrik saldırılara karşı Türkiye\'nin en güçlü savunma kalkanlarından birini sunar. Uygulama katmanı DDoS saldırılarına karşı ise akıllı rate limiting, davranış analizi ve CAPTCHA mekanizmaları devreye girer. CDN entegrasyonumuzu sayesinde meşru trafik hiçbir şekilde etkilenmeden saldırı trafiği filtrelenir.',
      ],
    },
    contentBlocks: [
      {
        title: '🔐 Kimlik ve Erişim Yönetimi (IAM)',
        paragraphs: [
          'Zero Trust güvenlik mimarisi ilkelerimiz gereği, ağınıza erişen her kullanıcı ve cihaz sürekli olarak doğrulanır. "Asla güvenme, her zaman doğrula" prensibi ile çalışan sistemlerimiz, şirket içi ve uzaktan çalışanlarınız için aynı düzeyde güvenlik sağlar. Multi-Factor Authentication (MFA), Single Sign-On (SSO) ve Privileged Access Management (PAM) çözümleri ile kimlik güvenliğinizi uçtan uca koruyoruz.',
          'Conditional access politikaları ile kullanıcının lokasyonuna, cihazına ve risk seviyesine göre dinamik erişim kuralları uygulanır. İstanbul ofisinden giriş yapan bir çalışan ile VPN üzerinden bağlanan bir uzak çalışanın farklı güvenlik doğrulama adımlarından geçmesi sağlanır. Bu sayede güvenlik ve kullanıcı deneyimi arasında optimum denge kurulur.',
        ],
      },
      {
        title: '🔍 Sızma Testi ve Güvenlik Denetimi',
        paragraphs: [
          'Periyodik sızma testleri (penetration testing) hizmetimiz, OWASP Top 10, SANS CWE Top 25 ve NIST çerçevelerine uygun olarak gerçekleştirilir. Sertifikalı pentest uzmanlarımız (OSCP, CEH, GPEN), ağ katmanı, web uygulaması, mobil uygulama ve sosyal mühendislik testlerini kapsamlı şekilde yürütür. Test sonuçları detaylı raporlanır ve düzeltme önerileriyle birlikte sunulur.',
          'Güvenlik açığı yönetimi (vulnerability management) hizmetimiz ile ağınızdaki tüm varlıklar düzenli olarak taranır, tespit edilen açıklar risk seviyesine göre önceliklendirilir ve yama yönetimi süreci koordine edilir. İstanbul, Ankara ve İzmir\'deki BT altyapınızın güvenlik duruşu sürekli olarak iyileştirilir.',
        ],
      },
    ],
    features: [
      { icon: '🔥', title: 'Yeni Nesil Firewall', desc: 'Derin paket inceleme, uygulama kontrolü, SSL inspection ve sandboxing ile gelişmiş tehdit koruması.' },
      { icon: '🛡️', title: 'IDS/IPS Sistemleri', desc: 'Saldırı tespit ve önleme sistemleri ile ağ trafiğinizin gerçek zamanlı korunması.' },
      { icon: '🌊', title: 'DDoS Koruma', desc: '10Tbps+ scrubbing kapasitesi ile hem volumetrik hem uygulama katmanı DDoS koruması.' },
      { icon: '🔐', title: 'Kimlik Yönetimi', desc: 'SSO, MFA, PAM ve Zero Trust mimarisi ile kapsamlı kimlik ve erişim yönetimi.' },
      { icon: '📧', title: 'E-posta Güvenliği', desc: 'Anti-spam, anti-phishing, sandbox analizi ve URL/ek dosya taraması ile güvenli e-posta.' },
      { icon: '🔍', title: 'SIEM & SOC', desc: 'İstanbul, Ankara ve İzmir SOC merkezlerimizden 7/24 güvenlik izleme ve olay müdahale.' },
    ],
    benefits: [
      'Çok katmanlı savunma ile kapsamlı siber koruma',
      'İstanbul, Ankara ve İzmir\'de 7/24 SOC izleme',
      'KVKK, GDPR ve ISO 27001 uyumluluk desteği',
      'Güvenlik farkındalığı eğitim programları',
      'Aylık güvenlik durum raporları ve threatbriefing',
      'Proaktif tehdit istihbaratı ve zafiyet yönetimi',
      'Olay müdahale planı ve kriz yönetimi desteği',
      'Sertifikalı uzman kadro (OSCP, CEH, CISSP)',
    ],
    useCases: [
      { icon: '🏦', title: 'Finans & Bankacılık', desc: 'PCI-DSS uyumlu ödeme altyapısı, BDDK regülasyonları kapsamında güvenlik denetimleri, fraud detection ve hassas finansal veri koruması. İstanbul finans merkezlerindeki müşterilerimize özel güvenlik çözümleri.' },
      { icon: '🏥', title: 'Sağlık Sektörü', desc: 'Hasta mahremiyeti ve tıbbi kayıt güvenliği. KVKK ve uluslararası sağlık veri güvenliği standartlarına uyumlu çözümler. İstanbul, Ankara ve İzmir\'deki hastane ve kliniklere özel güvenlik danışmanlığı.' },
      { icon: '🏛️', title: 'Kamu Kurumları', desc: 'Kritik altyapı koruması, e-devlet hizmetleri güvenliği ve milli siber güvenlik stratejisine uyumlu çözümler. Ankara\'daki kamu kurumlarına yakın SOC hizmeti.' },
      { icon: '🛒', title: 'E-Ticaret', desc: 'Ödeme güvenliği (PCI-DSS), müşteri verisi koruması, bot koruması ve web uygulama güvenliği. Yüksek trafikli kampanya dönemlerinde gelişmiş DDoS koruması.' },
    ],
    processSteps: [
      { num: 'ADIM 01', icon: '🔍', title: 'Güvenlik Değerlendirmesi', desc: 'Mevcut güvenlik duruşunuzun kapsamlı analizi, gap analizi ve risk değerlendirmesi.' },
      { num: 'ADIM 02', icon: '📐', title: 'Güvenlik Mimarisi Tasarımı', desc: 'Çok katmanlı savunma stratejisi, Zero Trust mimarisi ve güvenlik politikalarının tasarımı.' },
      { num: 'ADIM 03', icon: '🚀', title: 'Uygulama & Devreye Alma', desc: 'Güvenlik çözümlerinin kurulumu, konfigürasyonu ve mevcut altyapı ile entegrasyonu.' },
      { num: 'ADIM 04', icon: '📊', title: '7/24 İzleme & Müdahale', desc: 'İstanbul, Ankara ve İzmir SOC\'larından sürekli izleme, tehdit avcılığı ve olay müdahale.' },
    ],
    faq: [
      { q: 'SOC hizmetiniz hangi şehirlerde mevcut?', a: 'SOC operasyonlarımız İstanbul, Ankara ve İzmir\'deki merkezlerimizden 7/24 yürütülmektedir. Coğrafi yedekleme ile bir merkezde sorun olması durumunda diğer merkezler devralır.' },
      { q: 'DDoS korumanız ne kadar büyük saldırıları engelleyebilir?', a: '10 Tbps\'nin üzerinde scrubbing kapasitemiz ile dünyanın en büyük volumetrik DDoS saldırılarına karşı koruma sağlıyoruz.' },
      { q: 'Sızma testi ne sıklıkla yapılmalı?', a: 'Yılda en az iki kez kapsamlı sızma testi ve sürekli güvenlik açığı taraması öneriyoruz. PCI-DSS gereklilikleri için üç ayda bir test zorunludur.' },
      { q: 'KVKK uyumluluk denetimi yapıyor musunuz?', a: 'Evet, KVKK uyumluluk denetimi, veri envanterleme, aydınlatma metni hazırlama ve teknik tedbirlerin uygulanmasını kapsayan tam kapsamlı KVKK danışmanlığı sunuyoruz.' },
      { q: 'Bir siber saldırı durumunda yanıt süreniz nedir?', a: 'Kritik seviye olaylar için ortalama yanıt süremiz 15 dakikanın altındadır. Olay müdahale planımız NIST IR framework\'üne uygun olarak yapılandırılmıştır.' },
      { q: 'Güvenlik farkındalığı eğitimi veriyor musunuz?', a: 'Evet, İstanbul, Ankara ve İzmir ofislerimizde yüz yüze veya online güvenlik farkındalığı eğitimleri, simüle phishing testleri ve düzenli bilgilendirme bültenleri sunuyoruz.' },
    ],
    techSpecs: 'Fortinet FortiGate, Palo Alto PA-Series ve Check Point Quantum NGFW. CrowdStrike Falcon EDR/XDR. Splunk Enterprise SIEM. Cloudflare Enterprise DDoS koruması. MITRE ATT&CK tabanlı tehdit modelleme. OWASP ZAP ve Burp Suite Pro ile web güvenlik testleri. Tenable Nessus ve Qualys ile zafiyet yönetimi. Cisco Duo MFA ve CyberArk PAM.',
  },
};

function getDefaultSolutionDetail(solution) {
  return {
    longDesc: `EMUR Innovation ${solution.title} çözümü, İstanbul, Ankara ve İzmir'deki Tier 3+ veri merkezlerinde faaliyet gösteren uzman ekibimiz tarafından sunulmaktadır. ${solution.desc} Türkiye genelinde 300'ün üzerinde kurumsal müşteriye hizmet veren tecrübemizle, işletmenizin ${solution.title.toLowerCase()} ihtiyaçlarını en üst düzeyde karşılıyoruz. KVKK uyumlu, ISO 27001 sertifikalı altyapımız ile verileriniz Türkiye sınırları içinde güvenle yönetilir.`,
    stats: [
      { icon: '🏢', number: '3', text: 'Şehirde Hizmet' },
      { icon: '⚡', number: '%99.9', text: 'Uptime Garantisi' },
      { icon: '🔒', number: '%100', text: 'KVKK Uyumlu' },
      { icon: '👥', number: '300+', text: 'Mutlu Müşteri' },
    ],
    deepDive: {
      title: `🔎 ${solution.title} Hakkında`,
      paragraphs: [
        `${solution.title}, modern işletmelerin artan BT ihtiyaçlarına cevap vermek üzere tasarlanmış kapsamlı bir çözüm paketidir. EMUR Innovation olarak İstanbul, Ankara ve İzmir'deki veri merkezlerimiz ve uzman ekibimizle, işletmenizin teknoloji altyapısını geleceğe hazırlıyoruz. Hizmetlerimiz, sektörün en iyi uygulamalarına uygun şekilde tasarlanmış olup, her ölçekten işletmeye uyarlanabilir esneklikte sunulmaktadır.`,
        `Türkiye'de dijital dönüşümün hız kazandığı bu dönemde, ${solution.title.toLowerCase()} alanındaki ihtiyaçlar katlanarak artmaktadır. İşletmeler, rekabet avantajlarını korumak ve müşteri beklentilerini karşılamak için güçlü teknoloji altyapılarına ihtiyaç duymaktadır. EMUR Innovation, bu ihtiyaca İstanbul'daki iki veri merkezi, Ankara ve İzmir'deki lokasyonlarıyla kapsamlı bir şekilde yanıt vermektedir.`,
        `Çözümlerimiz kullandığın kadar öde modeliyle sunulur. Başlangıç yatırımı gerektirmeden, aylık sabit bir ücretle tüm altyapı ihtiyaçlarınızı karşılayabilirsiniz. Esnek sözleşme seçeneklerimizle kısa vadeli projelerde veya uzun vadeli operasyonlarda size en uygun modeli sunuyoruz. Her müşterimize özel atanan hesap yöneticimiz, ihtiyaçlarınızı yakından takip eder ve proaktif çözümler sunar.`,
        `7/24 teknik destek ekibimiz, İstanbul, Ankara ve İzmir ofislerinden hem uzaktan hem yerinde müdahale kapasitesine sahiptir. Proaktif izleme sistemlerimiz sayesinde sorunları siz fark etmeden tespit eder ve çözüme kavuştururuz. Aylık performans raporlarımız ve düzenli review toplantılarımız ile hizmet kalitemizi sürekli iyileştiriyoruz.`,
      ],
    },
    contentBlocks: [
      {
        title: `⚙️ ${solution.title} Altyapı Detayları`,
        paragraphs: [
          `${solution.title} çözümümüz, enterprise düzey donanım ve yazılım altyapısı üzerinde çalışmaktadır. İstanbul (Avrupa ve Anadolu yakası), Ankara ve İzmir'deki Tier 3+ sertifikalı veri merkezlerimizde barındırılan çözümlerimiz, N+1 UPS ve dizel jeneratör ile kesintisiz enerji sürekliliğine sahiptir.`,
          `Altyapımız çoklu Tier-1 internet servis sağlayıcısına (Türk Telekom, Superonline, TurkNet) BGP multipath ile bağlıdır. İstanbul, Ankara ve İzmir veri merkezlerimiz arasında yüksek kapasiteli dark fiber bağlantılar ile düşük gecikmeli veri transferi gerçekleştirilir.`,
        ],
      },
      {
        title: `🔐 Güvenlik ve KVKK Uyumluluk`,
        paragraphs: [
          `Tüm ${solution.title.toLowerCase()} çözümlerimiz KVKK ve ISO 27001 standartlarına tam uyumlu olarak sunulmaktadır. Verileriniz Türkiye Cumhuriyeti sınırları içinde saklanır ve işlenir. Fiziksel güvenlik katmanında biyometrik erişim kontrolü, 7/24 CCTV izleme ve güvenlik personeli bulunur.`,
          `Siber güvenlik katmanında yeni nesil firewall sistemleri, saldırı tespit ve önleme mekanizmaları, DDoS koruma çözümleri ve düzenli sızma testleri uygulanır. Tüm veriler AES-256 şifreleme ile korunur ve TLS 1.3 protokolü ile iletilir.`,
        ],
      },
    ],
    features: [
      { icon: '🔒', title: 'Güvenli Altyapı', desc: 'ISO 27001 sertifikalı, KVKK uyumlu Türkiye veri merkezlerinde güvenlik izleme.' },
      { icon: '⚡', title: 'Yüksek Performans', desc: 'Son teknoloji donanım, NVMe SSD depolama ve optimize yazılım altyapısı.' },
      { icon: '📈', title: 'Ölçeklenebilirlik', desc: 'İhtiyaçlarınıza göre büyüyebilen esnek mimari ve kaynak yönetimi.' },
      { icon: '🛠️', title: '7/24 Destek', desc: 'İstanbul, Ankara ve İzmir\'den uzaktan ve yerinde teknik destek.' },
      { icon: '💰', title: 'Maliyet Optimizasyonu', desc: 'Kullandığın kadar öde, esnek sözleşmeler ve şeffaf fiyatlandırma.' },
      { icon: '📊', title: 'Detaylı Raporlama', desc: 'Aylık performans raporları, dashboardlar ve maliyet analizi.' },
    ],
    benefits: [
      'İstanbul, Ankara ve İzmir\'de yerel destek',
      'KVKK uyumlu veri lokalizasyonu garantisi',
      'Deneyimli ve sertifikalı uzman ekip',
      'Proaktif izleme ve sorun öncesi müdahale',
      'Esnek sözleşme ve fiyatlandırma modelleri',
      'Hızlı kurulum ve devreye alma',
      'Düzenli güncelleme ve sürekli iyileştirme',
      '%99.9 SLA uptime garantisi',
    ],
    useCases: [
      { icon: '🏢', title: 'Kurumsal Şirketler', desc: 'İstanbul, Ankara ve İzmir\'deki büyük firmalar için enterprise düzey çözümler ve 7/24 yerinde destek.' },
      { icon: '🏪', title: 'KOBİ\'ler', desc: 'Küçük ve orta ölçekli işletmeler için uygun fiyatlı, başlangıç yatırımı gerektirmeyen esnek paketler.' },
      { icon: '🏛️', title: 'Kamu Kurumları', desc: 'KVKK uyumlu altyapı, yerli ve milli yazılım tercihleri. Ankara veri merkezimizden yakın hizmet.' },
      { icon: '📈', title: 'Büyüyen Startuplar', desc: 'Hızlı büyüme döneminde minimal kaynakla başlayıp ihtiyaç arttıkça otomatik genişleme.' },
    ],
    processSteps: [
      { num: 'ADIM 01', icon: '🔍', title: 'İhtiyaç Analizi', desc: 'İstanbul, Ankara veya İzmir ofislerimizde detaylı görüşme ve mevcut altyapı envanteri.' },
      { num: 'ADIM 02', icon: '📐', title: 'Çözüm Tasarımı', desc: 'İhtiyaçlarınıza özel mimari tasarım, güvenlik planı ve maliyet analizi.' },
      { num: 'ADIM 03', icon: '🚀', title: 'Kurulum & Devreye Alma', desc: 'Planlı kurulum, veri göçü ve kesintisiz geçiş süreci.' },
      { num: 'ADIM 04', icon: '📊', title: 'İzleme & Destek', desc: '7/24 proaktif izleme, aylık raporlama ve sürekli optimizasyon.' },
    ],
    faq: [
      { q: `${solution.title} çözümünüz hangi şehirlerde mevcut?`, a: 'İstanbul (Avrupa ve Anadolu yakası), Ankara ve İzmir\'de toplam 4 Tier 3+ veri merkezimiz bulunmaktadır.' },
      { q: 'KVKK uyumluluğu nasıl sağlanıyor?', a: 'Tüm veriler Türkiye sınırları içinde saklanır. ISO 27001 sertifikamız ve düzenli güvenlik denetimleri ile tam uyumluluk garanti edilir.' },
      { q: 'Minimum sözleşme süresi nedir?', a: 'Aylık sözleşme seçeneğimiz mevcuttur. Uzun vadeli taahhütlerde ek indirimler sunuyoruz.' },
      { q: 'Teknik destek nasıl sağlanıyor?', a: 'İstanbul, Ankara ve İzmir ofislerimizden 7/24 telefon, e-posta ve ticket sistemi ile destek sunuyoruz.' },
      { q: 'Migrasyon sürecinde kesinti olur mu?', a: 'Sıfır kesinti hedefli migrasyon planlarımız ile iş sürekliliğiniz korunur.' },
      { q: 'Fiyatlandırma nasıl çalışıyor?', a: 'Kullandığın kadar öde veya aylık sabit fiyat modelleri mevcuttur. Detaylı teklif için bizimle iletişime geçin.' },
    ],
    techSpecs: `${solution.title} çözümümüz, İstanbul, Ankara ve İzmir'deki Tier 3+ sertifikalı veri merkezlerinde enterprise düzey donanım üzerinde çalışır. Intel Xeon ve AMD EPYC işlemciler, NVMe SSD depolama, 10/25Gbps network. N+1 UPS ve jeneratör ile %100 enerji sürekliliği.`,
  };
}

function SolutionDetailPage({ solution }) {
  const detail = solutionDetails[solution.slug] || getDefaultSolutionDetail(solution);

  return (
    <>
      <section className="detail-hero">
        <div className="detail-hero-bg" />
        <div className="container">
          <div className="detail-hero-badge">
            <span className="detail-hero-icon">{solution.icon}</span>
            <span>{solution.desc}</span>
          </div>
          <h1 className="detail-hero-title">{solution.title}</h1>
          <p className="detail-hero-desc">{detail.longDesc}</p>
          <div className="detail-hero-locations">
            <div className="detail-location-item"><span className="loc-dot" /> İstanbul (Avrupa &amp; Anadolu)</div>
            <div className="detail-location-item"><span className="loc-dot" /> Ankara</div>
            <div className="detail-location-item"><span className="loc-dot" /> İzmir</div>
          </div>
          {detail.stats && (
            <div className="detail-hero-stats">
              {detail.stats.map((s, i) => (
                <div className="detail-hero-stat" key={i}>
                  <div className="stat-number">{s.number}</div>
                  <div className="stat-text">{s.text}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="service-detail">
        <div className="container">

          {detail.deepDive && (
            <div className="detail-full-content">
              <h3>{detail.deepDive.title}</h3>
              {detail.deepDive.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>
          )}

          <div className="detail-info-grid">
            <div className="detail-info-card">
              <h3>🎯 Teknik Özellikler</h3>
              <p>{detail.techSpecs}</p>
            </div>
            <div className="detail-info-card">
              <h3>✅ Avantajlar</h3>
              <ul>
                {detail.benefits.map((b, i) => <li key={i}>{b}</li>)}
              </ul>
            </div>
          </div>

          {detail.contentBlocks && (
            <div className="detail-content-sections">
              {detail.contentBlocks.map((block, i) => (
                <div className="detail-content-block" key={i}>
                  <h3>{block.title}</h3>
                  {block.paragraphs.map((p, j) => <p key={j}>{p}</p>)}
                </div>
              ))}
            </div>
          )}

          <div className="section-header">
            <div className="section-label">Özellikler</div>
            <h2 className="section-title">Neler Sunuyoruz?</h2>
          </div>
          <div className="detail-features">
            {detail.features.map((f, i) => (
              <div className="detail-feature-card" key={i}>
                <div className="feature-icon">{f.icon}</div>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>

          {detail.processSteps && (
            <>
              <div className="section-header">
                <div className="section-label">Süreç</div>
                <h2 className="section-title">Nasıl Çalışıyoruz?</h2>
              </div>
              <div className="detail-process-steps">
                {detail.processSteps.map((step, i) => (
                  <div className="detail-step-card" key={i}>
                    <div className="step-num">{step.num}</div>
                    <div className="step-icon">{step.icon}</div>
                    <h4>{step.title}</h4>
                    <p>{step.desc}</p>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="detail-use-cases">
            <h3>Kullanım Alanları</h3>
            <div className="use-case-grid">
              {detail.useCases.map((uc, i) => (
                <div className="use-case-item" key={i}>
                  <div className="uc-icon">{uc.icon}</div>
                  <div>
                    <h4>{uc.title}</h4>
                    <p>{uc.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {detail.faq && (
            <>
              <div className="section-header">
                <div className="section-label">S.S.S.</div>
                <h2 className="section-title">Sıkça Sorulan Sorular</h2>
              </div>
              <div className="detail-faq-grid">
                {detail.faq.map((item, i) => (
                  <div className="detail-faq-item" key={i}>
                    <h4>❓ {item.q}</h4>
                    <p>{item.a}</p>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="service-cta">
            <h3>Bu çözüm hakkında detaylı bilgi almak ister misiniz?</h3>
            <p>İstanbul, Ankara ve İzmir ofislerimizden uzman ekibimiz sizin için en uygun çözümü tasarlamaya hazır.</p>
            <Link to="/iletisim" className="btn">İletişime Geçin →</Link>
          </div>
        </div>
      </section>
    </>
  );
}

function Solutions() {
  const { slug } = useParams();

  if (slug) {
    const solution = allSolutions.find(s => s.slug === slug);
    if (solution) {
      return <SolutionDetailPage solution={solution} />;
    }
  }

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1>Çözümlerimiz</h1>
          <p>İstanbul, Ankara ve İzmir'deki veri merkezlerimizden yenilikçi BT çözümleri sunuyoruz.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="solutions-grid">
            {allSolutions.map((solution, idx) => (
              <Link to={solution.path} className="solution-card" key={idx}>
                <div className="solution-icon">{solution.icon}</div>
                <h3>{solution.title}</h3>
                <p>{solution.desc}</p>
                <span className="solution-link">Detaylı Bilgi →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Solutions;
